import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { emberPowerCalendarDayClasses } from 'ember-power-calendar/helpers/ember-power-calendar-day-classes';
import { toLocalTimeInBrowserTimezone } from 'frontend-utils/utils/dayjs';
import {
  isSameOrAfter,
  isSameOrBefore,
} from 'lumen/utils/dates/native-js-date-utils';

export default class MarketInsightEmberPowerCalendarDayClassesCustomHelper extends Helper {
  @service('hotel-and-market') hotelAndMarketService;

  compute([
    day,
    calendar,
    weeks,
    dayClass,
    calendarViewFilters,
    sidebarCalendarRange,
  ]) {
    let classNames = emberPowerCalendarDayClasses([
      day,
      calendar,
      weeks,
      dayClass,
    ]);

    // These styles are always added in MI custom days
    classNames +=
      ' day-cell day-market-demand-wrapper flex justify-center items-center';

    // If the day is disabled / out of range: add the disabled style and return the classNames immediately
    if (day.isDisabled) {
      classNames += ' day-market-demand-wrapper--disabled';
      return classNames;
    }

    // Check if the current day is within the sidebarCalendarRange
    let isInRange = false;
    if (sidebarCalendarRange) {
      // sidebarCalendarRange is in local hotel TZ, day (PowerCalendar) is in browser TZ
      const startDate = toLocalTimeInBrowserTimezone(
        sidebarCalendarRange.start,
        this.hotelAndMarketService.timezone,
      ).toDate();
      const endDate = toLocalTimeInBrowserTimezone(
        sidebarCalendarRange.end,
        this.hotelAndMarketService.timezone,
      ).toDate();
      isInRange =
        isSameOrBefore(day.date, endDate) && isSameOrAfter(day.date, startDate);
    }
    const isSelected = day.isSelected || isInRange;

    // Add a custom style for selected days
    if (isSelected) {
      classNames += ' day-market-demand-wrapper--selected';
    }

    // Add a custom style for days without data
    if (!day.hasMarketData) {
      classNames += ' day-market-demand-wrapper--no-market-data';
    }

    // Check if the demand colors should be shown
    if (calendarViewFilters && day.rateIndexLevelNumber) {
      let showDemandColorInCalendar = true;

      if (!calendarViewFilters.hasNoFilters) {
        if (
          calendarViewFilters.hasDemandIncreaseFilter &&
          !day.hasDemandIncrease
        ) {
          showDemandColorInCalendar = false;
        }
        if (
          calendarViewFilters.hasDemandDecreaseFilter &&
          !day.hasDemandDecrease
        ) {
          showDemandColorInCalendar = false;
        }
        if (
          calendarViewFilters.hasPriceHighFilter &&
          !day.hasPriceHighOutlier
        ) {
          showDemandColorInCalendar = false;
        }
        if (calendarViewFilters.hasPriceLowFilter && !day.hasPriceLowOutlier) {
          showDemandColorInCalendar = false;
        }
      }

      if (showDemandColorInCalendar) {
        classNames += ` rate-index-level-${day.rateIndexLevelNumber}`;
      } else {
        classNames += ' day-market-demand--not-highlighted'; // see CSS class (hides outliers/demand change for these days)
      }
    }

    return classNames;
  }
}
